import { REACT_QUERY_KEYS } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { useQuery } from '@tanstack/react-query';
import { container } from '../../DataDomain';
import { IGatewayService } from '../../application/services/GatewayService';
import { resolveWcpAppKey } from '../../../utils/resolveWcpAppKey';

export const useLanguageDataQuery = (
    language: string,
    enabled: boolean,
    callback: (languageDictionary: any) => void
) => {
    const appKey = resolveWcpAppKey();

    return useQuery({
        queryKey: [REACT_QUERY_KEYS.LANGUAGE_KEY, language, appKey],
        enabled: enabled && !!appKey,
        queryFn: async () => {
            if (!appKey) {
                throw new Error('No app key available for language fetch');
            }
            const gatewayService = container.resolve<IGatewayService>(DI.SERVICES.IGatewayService);
            const languageData = await gatewayService.getGatewayLanguage(appKey, 'en');
            const arData = await gatewayService.getGatewayLanguage(appKey, 'ar');

            const dictionary = { en: languageData, ar: arData };

            callback(dictionary);
            return dictionary;
        },
        retry: 1,
    });
};
